module.exports = __webpack_public_path__ + "static/media/element1.bf31ebb3.svg";